import React, { useEffect, useCallback, FunctionComponent, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { LOAD_STATUS, AUTOMATION_ID } from 'modules/common/constants';
import ErrorPage from 'modules/common/components/ErrorPage';
import SearchInput from 'modules/common/components/SearchInput';
import { LoadStatus } from 'modules/common/interfaces';
import OwnersList from '../OwnersList';

import local from './local.module.scss';

interface OwnersListLayoutProps {
    canView: boolean;
    canManage: boolean;
    status: LoadStatus;
    loadData: Function;
    onSearch: Function;
    resetTable: Function;
    goToAddOwnerPage: Function;
}

const OwnersListLayout: FunctionComponent<OwnersListLayoutProps> = (props) => {
    const { loadData, resetTable, canView, canManage, status, onSearch, goToAddOwnerPage } = props;

    useEffect(() => {
        if (canView) {
            resetTable();
            loadData();
        }
    }, []);

    const newOwnerButtonCallback = useCallback(() => { goToAddOwnerPage(); }, []);

    if (!canView) {
        return (
            <ErrorPage error='403' />
        );
    }

    const isLoaded = status === LOAD_STATUS.LOADED;

    return (
        <Fragment>
            <div className={local.title}>
                <FormattedMessage id='common.owners' />
            </div>
            <div className={classnames(local.tableControls, 'container-row')}>
                <SearchInput inputId={AUTOMATION_ID.OWNERS_SEARCH} disabled={!isLoaded} onSearch={onSearch} />
                {
                    canManage &&
                    <div className='ls-button'>
                        <button
                            id={AUTOMATION_ID.NEW_OWNER_BTN}
                            onClick={newOwnerButtonCallback}
                            disabled={!isLoaded}
                        >
                            <FormattedMessage id='admin.newOwner' />
                        </button>
                    </div>
                }
            </div>
            <div className={local.card}>
                <OwnersList />
            </div>
        </Fragment>
    );
};

export default OwnersListLayout;
